var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blok.language.length > 0)?_c('img',{class:_vm.classes,attrs:{"src":require(("~/assets/svg/flags/" + (_vm.blok.language.toLowerCase()) + ".svg")),"title":_vm.blok.language}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }